<template>
  <el-container class="userManagement-box" direction="vertical">
    <div class="search-x">
      <div class="title">服务使用情况</div>
      <el-row :gutter="10">
        <el-col :span="8"
          ><div class="grid-content">
            使用服务次数总计：{{ detailData.orderTotalCount }}
          </div></el-col
        >
      </el-row>
      <el-row :gutter="10" v-if="detailData.orderTotalCount > 0">
        <el-col :span="8"
          ><div class="grid-content">
            健康评估问卷次数：{{ detailData.orderTotalCount }}
          </div></el-col
        >
      </el-row>
      <el-row class="item-content" :gutter="10">
        <el-col :span="6" v-for="(item, index) in showHandleList" :key="index">
          <div class="grid-content">{{ item.keyName }}：{{ item.value }}</div>
        </el-col>
        <div
          class="show-more"
          v-if="itemDataList.length > 4"
          @click="showAll = !showAll"
        >
          {{ word }}
          <i
            :class="{
              'el-icon-d-arrow-left': !showAll,
              'el-icon-d-arrow-right': showAll,
            }"
          ></i>
        </div>
      </el-row>

      <div class="title">明细</div>
      <div class="cont-x">
        <div class="table-x" ref="tableBox">
          <el-table
            v-loading="loading"
            :data="detailData.orderList"
            border
            class="mb20"
          >
            <el-table-column
              type="index"
              align="center"
              width="60"
              label="序号"
            >
            </el-table-column>
            <el-table-column prop="orderNo" align="center" label="订单号">
            </el-table-column>
            <el-table-column
              prop="productName"
              align="center"
              label="服务名称"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="productType"
              align="center"
              label="服务分类"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              align="center"
              label="使用人"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="mobile"
              align="center"
              label="电话"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="relation"
              align="center"
              label="与权益人关系"
              width="160"
            >
              <template slot-scope="scoped">
                <span>{{ relation[scoped.row.relation] || "" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="state"
              align="center"
              label="状态"
              width="160"
            >
              <template slot-scope="scoped">
                <span>{{
                  scoped.row.state | typeFilter(scoped.row, serviceOrderState)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              align="center"
              label="状态更新时间"
              width="160"
            >
            </el-table-column>
            <el-table-column align="center" width="160" label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.orderType == 6 || scope.row.orderType == 7"
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toDetail(scope.row)"
                  >{{
                    scope.row.orderType == 6 || scope.row.orderType == 7
                      ? "状态轨迹"
                      : "查看"
                  }}</el-button
                >
                <el-button
                  v-if="scope.row.orderType == 8"
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toDetail(scope.row)"
                  >查看</el-button
                >
                <el-button
                  v-if="
                    scope.row.orderType == 6 && scope.row.reportAuditState == 3
                  "
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toHealthDetail(scope.row)"
                  >查看</el-button
                >
                <el-button
                  v-if="scope.row.orderType == 6 && scope.row.state == 3"
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="downPDF(scope.row.reportUrl)"
                  >下载</el-button
                >
                <el-button
                  v-if="scope.row.orderType == 7 && scope.row.examStatus == 8"
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="toPhysicalDetail(scope.row)"
                  >查看</el-button
                >
                <el-button
                  v-if="scope.row.orderType == 7 && scope.row.examStatus == 8"
                  size="middle"
                  class="mb10"
                  type="text"
                  @click="downloadFile(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- <div class="pagenation-x">
                <div class="pagination mb20">
                    <el-pagination
                        @size-change="getData"
                        @current-change="getData"
                        :current-page.sync="page.pageNo"
                        :page-size.sync="page.pageSize"
                        layout="total,  prev, pager, next, jumper"
                        :total="page.total"
                        background
                    >
                    </el-pagination>
                </div>
            </div> -->
      <ExpertAppointmentDialog ref="popup1" />
      <ExpertWardDialog ref="popup2" />
      <ExpertSurgeryDialog ref="popup3" />
      <TelephoneDoctorDialog ref="popup4" />
      <VideoDoctorDialog ref="popup5" />
      <HealthyDialog ref="popup6" />
      <PhysicalDialog ref="popup7" />
      <eva ref="popup8" />
    </div>
  </el-container>
</template>

<script>
import { orderState, serviceOrderState, relation } from "@/assets/js/options";
import ExpertAppointmentDialog from "@/components/order/expertAppointmentDialog.vue"; // 专家预约详情
import eva from "@/components/order/eva.vue"; // 查看问卷详情
import ExpertSurgeryDialog from "@/components/order/expertSurgeryDialog.vue"; // 专家手术详情
import ExpertWardDialog from "@/components/order/expertWardDialog.vue"; // 专家病房详情
import TelephoneDoctorDialog from "@/components/order/telephoneDoctorDialog.vue"; // 电话医生详情
import VideoDoctorDialog from "@/components/order/videoDoctorDialog.vue"; // 视频医生详情
import HealthyDialog from "@/components/order/healthyDialog.vue"; // 健康体检状态轨迹
import PhysicalDialog from "@/components/order/physicalDialog.vue"; // 核保体检状态轨迹
export default {
  name: "BasicInfo",
  components: {
    ExpertAppointmentDialog,
    ExpertSurgeryDialog,
    ExpertWardDialog,
    TelephoneDoctorDialog,
    VideoDoctorDialog,
    HealthyDialog,
    PhysicalDialog,
    eva,
  },
  data() {
    return {
      loading: false,
      orderState, // 订单状态list
      serviceOrderState, //各个服务的订单状态
      relation, // 与权益人关系list
      // 页数相关信息
      detailData: {
        orderTotalCount: "--",
      }, // 基本信息数据
      /**
       * 表格相关
       */
      // 页数相关信息
      loading: true,
      showAll: false, // 控制展示，收起
      serviceKeyList: [
        {
          // 服务项目
          keyName: "电话医生",
          keyValue: "callDoctorCount",
          value: 0,
        },
        {
          keyName: "视频医生",
          keyValue: "videoDoctorCount",
          value: 0,
        },
        {
          keyName: "专家预约",
          keyValue: "expertAppointmentCount",
          value: 0,
        },
        {
          keyName: "专家手术",
          keyValue: "expertSurgeryCount",
          value: 0,
        },
        {
          keyName: "专家病房",
          keyValue: "expertWardCount",
          value: 0,
        },
        {
          keyName: "健康体检",
          keyValue: "medicalCount",
          value: 0,
        },
        {
          keyName: "核保体检",
          keyValue: "examBookingCount",
          value: 0,
        },
      ],
      itemDataList: [], // 明细数据
    };
  },

  computed: {
    showHandleList() {
      if (this.showAll == false) {
        var showList = [];
        if (this.itemDataList.length > 4) {
          for (var i = 0; i < 4; i++) {
            showList.push(this.itemDataList[i]);
          }
        } else {
          showList = this.itemDataList;
        }
        return showList;
      } else {
        return this.itemDataList;
      }
    },
    word() {
      if (this.showAll == false) {
        return "展开全部";
      } else {
        return "收起";
      }
    },
  },
  mounted() {
    this.getData();
  },
  filters: {
    /**
     * 状态
     */
    typeFilter(text, row, serviceOrderState) {
      let orderType = row.orderType;
      let typeList = [];
      if (orderType == 6) typeList = serviceOrderState["healthyState"];
      else if (orderType == 7) typeList = serviceOrderState["physicalState"];
      else typeList = serviceOrderState["noHealthy"];
      if (orderType == 7) {
        let findItem = typeList.find((o) => o.value === row.examStatus);
        if (findItem && findItem["label"]) {
          return findItem["label"];
        } else {
          if (text == 1) return "待预约";
          if (text == 6) return "已撤销";
          if (text == 9) return "订单取消";
          if (text == 10) return "到检取消";
          return "未知";
        }
      } else {
        let t = typeList.find((el) => el.value == text)?.label || "";
        return t;
      }
    },
  },
  methods: {
    /* 获取 table 列表 */
    async getData() {
      this.loading = true;
      let res = await this.axios.get(this.getApiUrl("userDocOrderList"), {
        params: {
          userId: this.$store.state.healthDocUser.userId,
        },
      });
      if (res.code == 1) {
        this.detailData = res?.data || {};
        this.serviceKeyList.forEach((item) => {
          item.value = res.data[item.keyValue] || 0;
          if (item.value > 0) {
            this.itemDataList.push(item);
          }
        });
      } else {
        this.$message.error(res.msg);
      }

      this.loading = false;
    },
    /**
     * 换页
     */
    handleCurrentChange(val) {
      this.searchBox.pageNo = val;
      this.getData();
    },
    // orderTyp订单类型:1:专家预约 ; 2:专家病房 ; 3:专家手术 ; 4:电话医生 ;5:视频医生  ;6:健康体检|
    //  新增问卷类型 8
    toDetail(row) {
      this.$refs["popup" + row.orderType].showDetail(row);
    },

    // 跳转健康体检订单报告
    toHealthDetail(item) {
      this.$router.push({
        name: "ReportDetail",
        query: {
          id: item.id,
          orderNo: item.orderNo,
          reportSource: "MJK",
          source: 2, // 1核保体检2健康体检
          pathSource: "用户档案,健康体检,订单报告详情",
        },
      });
    },
    downloadFile(item) {
      let param = {
        bookingId: item.bookingId,
      };
      let urlPath = this.getApiUrl("orderReportDownload");
      this.$root.exportFile(urlPath, param, "核保体检订单报告", ".pdf");
    },
    toPhysicalDetail(item) {
      if (item.reportSource) {
        this.$router.push({
          name: "ReportDetail",
          query: {
            id: item.bookingId,
            orderNo: item.orderNo,
            reportSource: item.reportSource,
            source: 1, // 1核保体检2健康体检
            pathSource: "用户档案,核保体检订单,订单报告详情",
          },
        });
      } else {
        this.$message({
          type: "warning",
          message: "暂不支持此类型报告",
        });
      }
    },
    /**
     * 下载pdf
     */
    downPDF(url) {
      let cache = url.split("/");
      let name = cache[cache.length - 1].split(".");
      this.$root.exportFile(url, {}, name[0], "." + name[1]);
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
@import "@/assets/css/color.scss";
.userManagement-box {
  .search-x {
    min-height: 120px;
    flex-shrink: 0;
    padding-top: 20px;
  }
  .cont-x {
    flex: 1;
    flex-shrink: 0;
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  padding-left: 20px;
}
.el-col {
  margin-bottom: 10px;
}
.grid-label {
  display: inline-block;
  vertical-align: top;
}

.title {
  height: 30px;
  line-height: 30px;
  margin-bottom: 40px;
  font-weight: bold;
  padding-left: 20px;
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 8px;
    background-color: $theme;
  }
}
.item-content {
  position: relative;
  .show-more {
    position: absolute;
    right: 20px;
    bottom: 25px;
    cursor: pointer;
    color: $theme;
    font-size: 14px;
  }
  .el-icon-d-arrow-left {
    transform: rotate(-90deg);
  }
  .el-icon-d-arrow-right {
    transform: rotate(-90deg);
  }
}
</style>
